module.exports = __webpack_public_path__ + "img/civilservantcard.8a11a500.png";